import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddPosition = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/position`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const ongetOrgPosition = async (id:any,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/position/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
export{onAddPosition, ongetOrgPosition}